import { z } from 'zod';
import { IsoDateTimeSchema, TenantIdSchema, UuidSchema } from './common';

/**
 * Kollekció: szerző, témakör, sorozat vagy bármilyen csoportosítás.
 * Egy publikáció több kollekcióhoz is tartozhat (M:N).
 */
export const CollectionSchema = z.object({
  id: UuidSchema,
  tenantId: TenantIdSchema,
  slug: z.string().min(1).max(120),
  name: z.string().min(1).max(200),
  description: z.string().max(2000).nullable().optional(),
  coverUrl: z.string().url().nullable().optional(),
  /** Hány publikáció tagja a kollekciónak — denormalizált, gyors UI */
  itemCount: z.number().int().nonnegative().default(0),
  createdAt: IsoDateTimeSchema,
  updatedAt: IsoDateTimeSchema,
});
export type Collection = z.infer<typeof CollectionSchema>;

export const CreateCollectionSchema = CollectionSchema.pick({
  name: true,
  description: true,
}).extend({
  slug: z.string().min(1).max(120).optional(),
});
export type CreateCollectionInput = z.infer<typeof CreateCollectionSchema>;

export const UpdateCollectionSchema = CreateCollectionSchema.partial();
export type UpdateCollectionInput = z.infer<typeof UpdateCollectionSchema>;

/**
 * Egy kollekció rendezett tagja: a `position` mező adja a sorrendet.
 * A frontend drag&drop átszámozza, és batch-ben menti.
 */
export const CollectionItemSchema = z.object({
  publicationId: UuidSchema,
  title: z.string(),
  position: z.number().int().nonnegative(),
});
export type CollectionItem = z.infer<typeof CollectionItemSchema>;
